import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Row, Container, Form, Col, ToggleButtonGroup, ToggleButton, ListGroup } from 'react-bootstrap';
import * as Progress from '@radix-ui/react-progress';
import ForecastItem from './ForecastItem';
import { useSelector } from 'react-redux';
import SearchComponent from '../SearchComponent/SearchComponent';
import moment from 'moment';
import "./forecast.css";
import { CONSTANTS } from '../../config';

let weatherLayers = [
    {
        code: "clouds_new",
        label: "Clouds"
    },
    {
        code: "precipitation_new",
        label: "Precipitation"
    },
    {
        code: "pressure_new",
        label: "Pressure"
    },
    {
        code: "wind_new",
        label: "Wind"
    },
    {
        code: "temp_new",
        label: "Temperature"
    }
]



function ForecastTabs() {
    const [activeTab, setActiveTab] = useState("today");
    const [forecastData, setForecastData] = useState([]);

    const [selectedWeatherLayer, setSelectedWeatherLayer] = useState(weatherLayers[0]);

    const locationDetails = useSelector(state => state.locationReducer);
    console.log("🚀 ~ ForecastTabs ~ locationDetails:", locationDetails);

    const onClickTab = (key) => {
        setActiveTab(key);
    };

    const onClickWeatherLayer = (value) => {
        setSelectedWeatherLayer(value);
    };

    useEffect(() => {
        let filteredData = [];
        if (activeTab === "today") {
            filteredData = locationDetails.forecastData?.list?.filter(item => new Date(item.dt_txt).getDate() === new Date().getDate());
        } else if (activeTab === "tommorrow") {
            filteredData = locationDetails.forecastData?.list?.filter(item => new Date(item.dt_txt).getDate() === new Date().getDate() + 1);
        } else if (activeTab === "dayaftertommorrow") {
            filteredData = locationDetails.forecastData?.list?.filter(item => new Date(item.dt_txt).getDate() === new Date().getDate() + 2);
        } else if (activeTab === "4thDay") {
            filteredData = locationDetails.forecastData?.list?.filter(item => new Date(item.dt_txt).getDate() === new Date().getDate() + 3);
        } else if (activeTab === "5thDay") {
            filteredData = locationDetails.forecastData?.list?.filter(item => new Date(item.dt_txt).getDate() === new Date().getDate() + 4);
        }
        setForecastData(filteredData);

    }, [activeTab, locationDetails]);


    const { sys, name } = locationDetails.currentLocationData || {};

    return (
        <Row className="main-content-container">
            <Container sm={12} className='content-container pt-3'>

                {/* Search Component */}
                <Row className='dashboard-sc mt-3'>
                    <SearchComponent />
                </Row>

                <Row className='mb-3'>
                    <p className='m-0 pt-2 pb-1 home-cl' style={{ opacity: '0.5' }}>Current Location</p>
                    <p className='m-0 home-cl'>{name}, {sys?.country}</p>
                </Row>

                <p className='login-main-title' style={{ fontSize: '20px' }}>Forecast Details (5Days/3Hours)</p>

                <Tabs
                    defaultActiveKey="profile"
                    id="uncontrolled-tab-example"
                    activeKey={activeTab}
                    fill
                    onSelect={(k) => onClickTab(k)}
                    className="mb-3"
                >
                    <Tab eventKey="today" title="Today">
                    </Tab>
                    <Tab eventKey="tommorrow" title="Tomorrow">
                    </Tab>
                    <Tab eventKey="dayaftertommorrow" title="Day After Tomorrow">
                    </Tab>
                    <Tab eventKey="4thDay" title="4 Day">
                    </Tab>
                    <Tab eventKey="5thDay" title="5th Day">
                    </Tab>
                </Tabs>
                <Row className='row-gap-3'>
                    {
                        forecastData && forecastData.map(item => <ForecastItem details={item} />)
                    }
                </Row>

                <div className='pt-4 pb-2'>
                    <Form.Text className='p-0 login-main-title' style={{ fontSize: '20px' }}>Chances of rain</Form.Text>
                    <Row className='row-gap-5'>
                        <Col sm={12} md={5} className='d-flex flex-column pt-4 gap-4'>
                            {
                                forecastData && forecastData.map(item => (
                                    <div className='d-flex gap-1'>
                                        <Form.Text className='time-text'>{moment(item.dt_txt).format("hh:mm A")}</Form.Text>
                                        <Progress.Root className="ProgressRoot" value={item?.clouds?.all}>
                                            <Progress.Indicator
                                                className="ProgressIndicator"
                                                style={{ transform: `translateX(-${100 - item?.clouds?.all}%)` }}
                                            />
                                        </Progress.Root>
                                        <Form.Text className='time-text'>{item?.clouds?.all}%</Form.Text>

                                    </div>
                                ))
                            }
                        </Col>
                        <Col sm={12} md={7}>
                            <Row className='row-gap-3'>
                                <Col>
                                    <Form.Text className='p-0 login-main-title' style={{ fontSize: '20px' }}>Select Weather Layer</Form.Text>
                                    <br />
                                    <Form.Text>Selected Layer: {selectedWeatherLayer.label}</Form.Text>
                                    <ListGroup>
                                        <ListGroup.Item action onClick={() => onClickWeatherLayer(weatherLayers[0])}>{weatherLayers[0].label}</ListGroup.Item>
                                        <ListGroup.Item action onClick={() => onClickWeatherLayer(weatherLayers[1])}>{weatherLayers[1].label}</ListGroup.Item>
                                        <ListGroup.Item action onClick={() => onClickWeatherLayer(weatherLayers[2])}>{weatherLayers[2].label}</ListGroup.Item>
                                        <ListGroup.Item action onClick={() => onClickWeatherLayer(weatherLayers[3])}>{weatherLayers[3].label}</ListGroup.Item>
                                        <ListGroup.Item action onClick={() => onClickWeatherLayer(weatherLayers[4])}>{weatherLayers[4].label}</ListGroup.Item>
                                    </ListGroup>
                                </Col>
                                <Col>
                                    <img className='bg-dark' src={`https://tile.openweathermap.org/map/${selectedWeatherLayer.code}/1/1/1.png?appid=${CONSTANTS.API_KEY}`} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>

            </Container>
        </Row>

    );
}

export default ForecastTabs;